import apiClient from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Upload a single file
 * @param {File} file - The file to upload
 * @returns {Promise} Response with uploaded file URL
 */
export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    return await apiClient.post(API_ENDPOINTS.UPLOAD.SINGLE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    throw new Error(handleError(error, 'uploadService.uploadFile'));
  }
};

/**
 * Upload multiple files
 * @param {File[]} files - Array of files to upload
 * @returns {Promise} Response with uploaded file URLs
 */
export const uploadMultipleFiles = async (files) => {
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    return await apiClient.post(API_ENDPOINTS.UPLOAD.MULTIPLE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    throw new Error(handleError(error, 'uploadService.uploadMultipleFiles'));
  }
};

/**
 * Upload vehicle images
 * @param {File[]} images - Array of image files
 * @returns {Promise} Response with uploaded image URLs
 */
export const uploadVehicleImages = async (images) => {
  try {
    const formData = new FormData();
    images.forEach((image) => {
      formData.append('images', image);
    });

    return await apiClient.post(API_ENDPOINTS.UPLOAD.IMAGES, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    throw new Error(handleError(error, 'uploadService.uploadVehicleImages'));
  }
};

/**
 * Upload vehicle documents
 * @param {Object} documents - Object with registrationCardFront, registrationCardBack, ministryAuthorization
 * @returns {Promise} Response with uploaded document URLs
 */
export const uploadVehicleDocuments = async (documents) => {
  try {
    const formData = new FormData();
    if (documents.registrationCardFront) {
      formData.append('registrationCardFront', documents.registrationCardFront);
    }
    if (documents.registrationCardBack) {
      formData.append('registrationCardBack', documents.registrationCardBack);
    }
    if (documents.ministryAuthorization) {
      formData.append('ministryAuthorization', documents.ministryAuthorization);
    }

    return await apiClient.post(API_ENDPOINTS.UPLOAD.DOCUMENTS, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    throw new Error(handleError(error, 'uploadService.uploadVehicleDocuments'));
  }
};

